import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, ListFilter, Webhook, KeyRound, CreditCard, Settings, LogOut } from 'lucide-react';
import { logout } from '../../lib/auth.js';

const navItems = [
  { to: '/console/overview', label: 'Overview', icon: LayoutDashboard },
  { to: '/console/watchlists', label: 'Watchlists', icon: ListFilter },
  { to: '/console/webhooks', label: 'Webhooks', icon: Webhook },
  { to: '/console/keys', label: 'API Keys', icon: KeyRound },
  { to: '/console/billing', label: 'Billing', icon: CreditCard },
  { to: '/console/settings', label: 'Settings', icon: Settings },
];

export default function ConsoleLayout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div style={shell}>
      <aside style={sidebar}>
        <div style={logoWrap}>
          <span style={logo}>tender-api</span>
        </div>
        <nav style={nav}>
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              style={({ isActive }) => ({
                ...navLink,
                background: isActive ? 'var(--accent-soft)' : 'transparent',
                color: isActive ? 'var(--accent)' : 'var(--fg-2)',
              })}
            >
              <Icon size={16} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div style={sidebarFooter}>
          <button onClick={handleLogout} style={logoutBtn}>
            <LogOut size={16} />
            <span>Sign out</span>
          </button>
        </div>
      </aside>
      <main style={content}>
        <Outlet />
      </main>
    </div>
  );
}

const shell = {
  display: 'flex',
  minHeight: '100vh',
  background: 'var(--bg-1)',
};

const sidebar = {
  width: 220,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid var(--line-1)',
  background: 'var(--bg-2)',
  padding: 'var(--space-4) 0',
};

const logoWrap = {
  padding: 'var(--space-3) var(--space-4)',
  marginBottom: 'var(--space-4)',
};

const logo = {
  fontFamily: 'var(--font-mono)',
  fontSize: 'var(--fs-14)',
  fontWeight: 600,
  color: 'var(--fg-0)',
  letterSpacing: 'var(--tracking-tight)',
};

const nav = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: '0 var(--space-2)',
  flex: 1,
};

const navLink = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--space-2)',
  padding: 'var(--space-2) var(--space-3)',
  borderRadius: 'var(--r-1)',
  fontSize: 'var(--fs-13)',
  textDecoration: 'none',
  transition: 'background 0.15s, color 0.15s',
};

const sidebarFooter = {
  padding: 'var(--space-3) var(--space-2)',
  borderTop: '1px solid var(--line-1)',
  marginTop: 'auto',
};

const logoutBtn = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--space-2)',
  padding: 'var(--space-2) var(--space-3)',
  borderRadius: 'var(--r-1)',
  fontSize: 'var(--fs-13)',
  color: 'var(--fg-3)',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  width: '100%',
};

const content = {
  flex: 1,
  padding: 'var(--space-6)',
  overflow: 'auto',
};
